"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTypo = void 0;
const react_1 = __importDefault(require("react"));
const _helper_1 = require("../assets/js/_helper");
const FTypo = ({ className = "", display = "block", width, size = 16, lineHeight = size + 5, weight, color, family, align = "", alignX = "", alignY = "", truncate, children = undefined, }) => {
    return (react_1.default.createElement("span", { className: `f-typo f-typo-align-${align} d-${display} ${display === "block" ? "w-100" : ""} ${display === "flex" ? `jc jc-${alignX} ai ai-${alignY}` : display} ${className}`, style: {
            fontSize: size,
            lineHeight: `${lineHeight}px`,
            fontWeight: weight,
            color: color,
            fontFamily: family,
            maxWidth: `${width}px`,
        }, title: children }, truncate ? (0, _helper_1.truncateText)(children, truncate.truncateLength, truncate.truncatePosition) : children));
};
exports.FTypo = FTypo;
//# sourceMappingURL=Ftypo.js.map